<template>
  <DocumentationDownload
    v-if="data?.fields?.type === 'Documentation Download'"
    :data="data"
  />
  <MarketingMaterial
    v-else-if="data?.fields?.type === 'Marketing Material'"
    :data="data"
  />
</template>

<script setup lang="ts">
import DocumentationDownload from './DocumentationDownload.vue'
import MarketingMaterial from './MarketingMaterial.vue'

import type { TypeEntriesCollectionWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeEntriesCollectionWithoutUnresolvableLinksResponse
}>()
</script>
